<template>
  <section>
    <h3 class="primary--text"><v-icon info>person_outline</v-icon> Solicitudes de trámites de la entidad</h3>

    <v-card>
      <v-card-text>
        <crud-table
          :headers="$store.state.user.id_rol === 3 || $store.state.user.id_rol === 4? headers_pago : headers_sin_pago"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          :data-graphql="dataGraphql"
          :widthModal="800"
          :checkbox="$store.state.user.id_rol === 7 || $store.state.user.id_rol === 4"
          :showFilter="true"
        >
          <template slot="buttons">
            <v-tooltip bottom v-if="$store.state.user.id_rol === 7  || $store.state.user.id_rol === 4">
              <v-btn
                @click="openFirmanteGrupal()"
                slot="activator"
                color="success">
                <v-icon>check</v-icon> Firmar
              </v-btn>
              <span>Firmar documentos seleccionados</span>
            </v-tooltip>
          </template>

          <template slot="labels">
            <div class="text-xs-right" v-if="this.regionales.length > 1">
              <v-select
                label="Regional"
                v-model="regional"
                :items="regionales"
              ></v-select>
            </div>
            <div class="text-xs-right" v-else>
              <strong>REGIONAL:</strong>
              <v-chip label color="info" text-color="white">
                {{ user.departamento.split(',').join(' - ') }}
              </v-chip>
            </div>
          </template>

          <template slot="items" slot-scope="items">
            <td class="text-xs-right">
              {{items.item.id}}
            </td>
            <td class="nowrap">
              <v-btn
                small
                v-if="$store.state.user.id_rol === 3 || $store.state.user.id_rol === 6"
                @click="openRevisor(items.item)">
                <v-icon>edit</v-icon> Ver detalles
              </v-btn>
              <v-btn
                small
                v-if="$store.state.user.id_rol === 4 || $store.state.user.id_rol === 7"
                @click="openFirmante(items.item)">
                <v-icon>edit</v-icon> Ver detalles
              </v-btn>
            </td>
            <td>
              <v-chip label :color="estados[items.item.estado]" text-color="white" v-if="items.item.documento_derivar === 'CANCILLERIA' && items.item.estado === 'FIRMADO_ENTIDAD'">
                <small>CREADO - CANCILLERIA</small>
              </v-chip>

              <v-chip label :color="estados[items.item.estado]" text-color="white" v-else>
                <small>{{ items.item.estado.replace(/_/gi, ' ') }}</small>
              </v-chip>
            </td>
            <td>{{ items.item.tramite_cod_seguimiento }}</td>
            <td>{{ items.item.documento_nombre }}</td>
            <td>
              <em><strong>{{ items.item.tramite_solicitante_tipo_documento }}: </strong>
                {{ items.item.tramite_solicitante_nro_documento }}</em><br>
              {{ items.item.tramite_solicitante_nombres }}
              {{ items.item.tramite_solicitante_primer_apellido }}
              {{ items.item.tramite_solicitante_segundo_apellido }}
            </td>
            <td>{{ $datetime.format(items.item._created_at) }}</td>

            <td class="text-xs-center" v-if="$store.state.user.id_rol === 4 || $store.state.user.id_rol === 3" >
              <v-icon v-if="items.item.pago_entidad || items.item.pago_cancilleria" color="success">check</v-icon>
              <v-icon v-else color="error">close</v-icon>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="$store.state.modal2" persistent scrollable max-width="1200" v-if="$store.state.user.id_rol === 6 || $store.state.user.id_rol === 3">
        <revisor :solicitud="solicitud" v-if="solicitud"></revisor>
    </v-dialog>
    <v-dialog v-model="$store.state.modal3" persistent scrollable max-width="1200" v-if="$store.state.user.id_rol === 4 || $store.state.user.id_rol === 7">
        <firmante :solicitud="solicitudC" v-if="solicitudC"></firmante>
    </v-dialog>
    <v-dialog v-model="$store.state.modal7" persistent scrollable max-width="1200" v-if="$store.state.user.id_rol === 4 || $store.state.user.id_rol === 7">
        <Firmantegrupal :solicitud="solicitudC" persistent scrollable v-if="firmador"></Firmantegrupal>
    </v-dialog>
  </section>
</template>
<script>
import CrudTable from '@/common/util/crud-table/CrudTable.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';
import tramiteDoc from './mixins/tramite_doc';
import Revisor from './Revisor';
import Firmante from './Firmante';
import Firmantegrupal from './FirmanteGrupal';
import { mapState } from 'vuex';
import usuario from '@/components/admin/usuario/mixins/usuario';

const estados = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'info',
  OBSERVADO_ENTIDAD_REVISOR: 'warning',
  OBSERVADO_ENTIDAD_FIRMANTE: 'warning',
  FIRMADO_ENTIDAD: 'success',
  REVISADO_CANCILLERIA: 'info',
  OBSERVADO_CANCILLERIA_REVISOR: 'warning',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'warning',
  APOSTILLADO: 'primary'
};

const regionales = [
  'LA PAZ',
  'COCHABAMBA',
  'SANTA CRUZ'
];

export default {
  mixins: [ crud, tramiteDoc, usuario ],
  created () {
    this.$store.state.modal2 = false;
    this.$store.state.modal3 = false;
    this.user = this.$storage.getUser();
    this.usuario = this.user.usuario;
    this.departamento = this.user.departamento;
    this.documentos = [];
    this.getDocumentos(1);
    this.regionales = this.user.departamento.split(',');

    if (this.regionales.length === 1 && this.regionales[0].length < 1) {
      this.getRegionales();
    }

    this.loadMaxFilesize();
    // this.regional = this.user.departamento;

    this.filters = [
      {
        field: 'id',
        label: 'Nro. de tramite',
        type: 'text',
        typeG: 'Int'
      },
      {
        field: 'id_documento',
        label: this.$t('tramite_doc.crud.docName'),
        type: 'select',
        typeG: 'Int',
        items: []
      },
      {
        field: 'cod_seguimiento',
        label: 'Código de seguimiento',
        type: 'text',
        typeG: 'String'
      },
      {
        field: 'nro_documento',
        label: 'Nro. de documento solicitante',
        type: 'text',
        typeG: 'String'
      },
      {
        field: 'nombre_completo',
        label: 'Nombre del solicitante',
        type: 'text',
        typeG: 'String'
      },
      {
        field: 'departamento',
        label: 'Regional',
        type: 'hidden',
        typeG: 'String',
        value: this.departamento

      },
      {
        field: 'estado',
        label: this.$t('tramite_doc.crud.status'),
        type: 'select',
        typeG: 'EstadoTramiteDoc',
        items: [
          { value: '', text: 'TODOS' },
          { value: 'CREADO', text: 'CREADO' },
          { value: 'REVISADO_ENTIDAD', text: 'REVISADO ENTIDAD' },
          { value: 'OBSERVADO_ENTIDAD_REVISOR', text: 'OBSERVADO ENTIDAD REVISOR' },
          { value: 'OBSERVADO_ENTIDAD_FIRMANTE', text: 'OBSERVADO ENTIDAD FIRMANTE' },
          { value: 'FIRMADO_ENTIDAD', text: 'FIRMADO ENTIDAD' },
          { value: 'REVISADO_CANCILLERIA', text: 'REVISADO CANCILLERIA' },
          { value: 'OBSERVADO_CANCILLERIA_REVISOR', text: 'OBSERVADO CANCILLERIA REVISOR' },
          { value: 'OBSERVADO_CANCILLERIA_FIRMANTE', text: 'OBSERVADO CANCILLERIA FIRMANTE' },
          { value: 'APOSTILLADO', text: 'APOSTILLADO' }
        ]
      }
    ];

    if ([6, 7, 3, 4].indexOf(this.user.id_rol) !== -1) {
      this.filters.push({
        field: 'no_estado',
        label: this.$t('tramite_doc.crud.status'),
        type: 'hidden',
        typeG: 'EstadoTramiteDoc',
        value: ''
      });

      switch (this.user.id_rol) {
        case 6: // rol: Revisor Entidad
          this.filters[this.filters.length - 2].items = [
            { value: '', text: 'TODOS' },
            { value: 'CREADO', text: 'CREADO' },
            { value: 'OBSERVADO_ENTIDAD_FIRMANTE', text: 'OBSERVADO ENTIDAD FIRMANTE' },
            { value: 'OBSERVADO_ENTIDAD_REVISOR', text: 'OBSERVADO ENTIDAD REVISOR' },
            { value: 'OBSERVADO_CANCILLERIA_REVISOR', text: 'OBSERVADO CANCILLERIA REVISOR' }
          ];
          this.filters[this.filters.length - 1].value = 'REVISADO_ENTIDAD';
          break;
        case 7: // rol: Firmador Entidad
          this.filters[this.filters.length - 2].items = [
            { value: '', text: 'TODOS' },
            { value: 'REVISADO_ENTIDAD', text: 'REVISADO ENTIDAD' }
          ];
          this.filters[this.filters.length - 1].value = 'FIRMADO_ENTIDAD';
          break;
        case 3: // rol: Revisor Cancilleria
          this.filters[this.filters.length - 2].items = [
            { value: '', text: 'TODOS' },
            { value: 'FIRMADO_ENTIDAD', text: 'FIRMADO ENTIDAD' },
            { value: 'OBSERVADO_CANCILLERIA_FIRMANTE', text: 'OBSERVADO CANCILLERIA FIRMANTE' }
          ];
          this.filters[this.filters.length - 1].value = 'REVISADO_CANCILLERIA';
          break;
        case 4: // rol: Firmador Cancilleria
          this.filters[this.filters.length - 2].items = [
            { value: '', text: 'TODOS' },
            { value: 'REVISADO_CANCILLERIA', text: 'REVISADO CANCILLERIA' }
          ];
          this.filters[this.filters.length - 1].value = 'APOSTILLADO';
          break;
        default:
          this.filters[this.filters.length - 1].value = 'NINGUNO';
      }
    }
  },
  data () {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'tramiteDocs',
      firmador: false,
      headers_sin_pago: [
        { text: 'N° Trámite', value: 'id' },
        { text: this.$t('common.actions'), sortable: false },
        { text: this.$t('tramite_doc.crud.estado'), value: 'estado' },
        { text: this.$t('tramite_doc.crud.tramite_cod_seguimiento'), value: 'tramite_cod_seguimiento' },
        { text: this.$t('tramite_doc.crud.documento_nombre'), value: 'id_documento' },
        { text: this.$t('tramite_doc.crud.nombre_solicitante'), value: 'id_tramite' },
        { text: this.$t('tramite_doc.crud.fecha_solicitud'), value: '_created_at' }
      ],
      headers_pago: [
        { text: 'N° Trámite', value: 'id' },
        { text: this.$t('common.actions'), sortable: false },
        { text: this.$t('tramite_doc.crud.estado'), value: 'estado' },
        { text: this.$t('tramite_doc.crud.tramite_cod_seguimiento'), value: 'tramite_cod_seguimiento' },
        { text: this.$t('tramite_doc.crud.documento_nombre'), value: 'id_documento' },
        { text: this.$t('tramite_doc.crud.nombre_solicitante'), value: 'id_tramite' },
        { text: this.$t('tramite_doc.crud.fecha_solicitud'), value: '_created_at' },
        { text: this.$t('tramite_doc.crud.pago'), value: 'pago_entidad', sortable: true }
      ],
      order: ['id', 'DESC'],
      regionales,
      regional: '',
      dataGraphql: `
        id
        pago_entidad
        pago_cancilleria
        cod_seguridad
        nro_apostilla
        fecha_expedicion
        estado
        observacion
        firmante_documento_nombre
        firmante_documento_cargo
        firmante_documento_entidad
        id_tramite
        id_documento
        id_archivo
        documento_id_entidad
        documento_nombre
        documento_derivar
        tramite_solicitante_nombres
        tramite_solicitante_primer_apellido
        tramite_solicitante_segundo_apellido
        tramite_solicitante_nro_documento
        tramite_solicitante_tipo_documento
        tramite_solicitante_fecha_nacimiento
        tramite_solicitante_email
        _created_at
        tramite_cod_seguimiento
      `,
      filters: this.filters,
      tramite_doc: null,
      valid: true,
      solicitud: null,
      solicitudC: null,
      estados,
      user: {}
    };
  },
  methods: {
    loadMaxFilesize () {
      this.$service.graphql({
        query: `
          query get {
            parametroBuscar(name: "MAX_FILESIZE") {
              valor
            }
          }
        `
      }).then(response => {
        if (response) {
          this.$store.commit('setMaxFilesize', parseInt(response.parametroBuscar.valor));
        }
      });
    },
    openRevisor (item) {
      if (item.estado === 'FIRMADO_ENTIDAD' && item.id_archivo > 1 && item.documento_derivar === 'ENTIDAD') {
        this.$service.get(`eapostilla/mostrar_firmante/${item.id_archivo}`)
          .then(response => {
            item.firmante = response;
            this.solicitud = null;
            this.$nextTick(() => {
              this.solicitud = item;
              this.$store.commit('openModal', 2);
            });
          });
      } else {
        if (item.id_archivo > 1) {
          this.$service.get(`eapostilla/mostrar_firma/${item.id_archivo}`)
            .then(response => {
              item.firmante = response;
              this.solicitud = null;
              this.$nextTick(() => {
                this.solicitud = item;
                this.$store.commit('openModal', 2);
              });
            });
        } else {
          this.solicitud = null;
          this.$nextTick(() => {
            this.solicitud = item;
            this.$store.commit('openModal', 2);
          });
        }
      }
    },
    openFirmante (item) {
      document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
      if (item.estado === 'REVISADO_CANCILLERIA' && item.id_archivo > 1 && item.documento_derivar === 'ENTIDAD') {
        this.$service.get(`eapostilla/mostrar_firmante/${item.id_archivo}`)
        .then(response => {
          item.firmante = response;
          this.solicitudC = null;
          this.$nextTick(() => {
            this.solicitudC = item;
            this.$store.commit('openModal', 3);
          });
        });
      } else {
        if (item.id_archivo > 1) {
          this.$service.get(`eapostilla/mostrar_firma/${item.id_archivo}`)
            .then(response => {
              item.firmante = response;
              this.solicitudC = null;
              this.$nextTick(() => {
                this.solicitudC = item;
                this.$store.commit('openModal', 3);
              });
            });
        } else {
          this.solicitudC = null;
          this.$nextTick(() => {
            this.solicitudC = item;
            this.$store.commit('openModal', 3);
          });
        }
      }
    },
    openFirmanteGrupal () {
      if (this.$store.state.selected.length === 0) {
        this.$message.warning('Debe seleccionar por lo menos un documento para firmar.');
        return false;
      }
      this.firmador = false;
      this.$nextTick(() => {
        this.firmador = true;
        this.$store.commit('openModal', 7);
      });
    }
  },
  components: {
    CrudTable,
    Revisor,
    Firmante,
    Firmantegrupal
  },
  computed: {
    ...mapState(['modal2', 'modal3'])
  },
  watch: {
    '$store.state.modal2': function (val) {
      if (!val) {
        this.$store.commit('setArchivo', 1);
      }
    },
    '$store.state.modal3': function (val) {
      if (!val) {
        this.$store.commit('setArchivo', 1);
      }
    },
    'regional': function (val) {
      if (val) {
        console.log('dep', val);
        this.filters[5].value = val;
        this.updateList();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// TramiteDoc.vue?3a098454